import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

// Components
import Layout from "../../../../Layout/Layout";
import { InputField } from "../../../../Components/formElements/InputField";
import { getTodayDate } from "../../../../common/Validations";
import DataTable from "react-data-table-component";
// import toast from "react-hot-toast";
import EstimateMaterialSelectionModal from "../Estimation/EstimateMaterialSelectionModal";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import toast from "react-hot-toast";
import CustomerConstants from "../../../../common/CustomerConstants";
import { useNavigate } from "react-router-dom";
import ItemService from "../../../../services/customer_appCommonService";
import { useDispatch, useSelector } from "react-redux";
import { setEstimationData } from "../../../../redux/feature/customer_app/customerV1Slice";
import EstimateUploadModal from "../Estimate/EstimateUploadModal";
// import ItemServiceV2 from "../../../../services/customer_v2_appCommonService";
import EstimateUploadDataViewModal from "../Estimate/EstimateUploadDataViewModal";
import RichTextEditor from "../../../../Components/Editor/RichTextEditor";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";

const num = (v) =>
  v === "" || v === null || v === undefined ? 0 : Number(v) || 0;

const EstimationCreationworkFlow = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const location = useLocation();

  const estimationData = useSelector(
    (state) => state.customerV1.estimationDraft.estimationData
  );
  let workflow = useSelector((state) => state?.customer?.customerWorkflow)

  const [isCardVisible2, setCardVisible2] = useState(true);
  // const [getDropdownData, setDropdownData] = useState("");
  const [isCardVisible6, setCardVisible6] = useState(true);
  const [isCardVisible1, setCardVisible1] = useState(true);

  // eslint-disable-next-line
  const toggleCardVisibility6 = () => setCardVisible6(!isCardVisible6);

  // const [activeBlockIndex, setActiveBlockIndex] = useState(null);   // normal blocks
  const [activeComponentKey, setActiveComponentKey] = useState(null); // component blocks

  const [disabled, setDisabled] = useState();
  const [getRemarks, setRemarks] = useState({});

  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  // eslint-disable-next-line
  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };
  const [visibleBlocks, setVisibleBlocks] = useState({});

  const toggleCardVisibility = (key) => {
    setVisibleBlocks((prev) => ({
      ...prev,
      [key]: !prev[key], // toggle only clicked block
    }));
  };

  // handleDraft
  const handleDraft = async () => {
    try {
      const filteredFormInputs = Object.fromEntries(
        Object.entries(formInputs).filter(([_, value]) => {
          if (typeof value === "string") return value.trim() !== "";
          if (typeof value === "boolean") return value === true;
          return value !== null && value !== undefined;
        })
      );

      const obj = {
        ...formInputs,
        estimationDetailsRemarks: getRemarks?.estimationDetailsRemarks,
        additionalComponent: filteredFormInputs,
        componentBlocks: componentBlockData,

        grandTotalPrice: grandTotals?.totalPrice,
        grandTotalWeight: grandTotals?.totalWeight,
        getOverallBuildingArea,

        buildings: buildings,
        buildingCount: buildingCount,
        activeBuildingId: activeBuildingId,
        draftStatus: "DF",
        headerStatus: "Estimation Draft",
        estHeaderStatus: "Estimation Draft",
        documentNumber: estimationData?.estimationNr || "",
      };

      setDisabled(true);
      const item = await ItemService.updateEstimation(obj);

      if (item?.status === 200) {
        const updatedData = {
          ...estimationData,
          additionalComponent: filteredFormInputs,
          componentBlocks: componentBlockData,
          buildings: buildings,
          buildingCount: buildingCount,
          activeBuildingId: activeBuildingId,
          grandTotalPrice: grandTotals?.totalPrice,
          grandTotalWeight: grandTotals?.totalWeight,
          draftStatus: "DF",
          headerStatus: "Estimation Draft",
        };
        dispatch(setEstimationData(updatedData));

        toast.success(item?.message || "Updated successfully", {
          duration: 2000,
          position: "top-right",
        });
        setDisabled(false);
        // navigate(
        //   CustomerConstants.CUSTOMER_V4_CUSTOMER_ESTIMATE_SPECIFICATION_LIST
        // );
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    } catch (error) {
      console.error("Update failed:", error);
      toast.error("Something went wrong, please try again later!", {
        duration: 4000,
        position: "top-right",
      });
    }
  };

  const handleSave = async () => {
    try {
      const filteredFormInputs = Object.fromEntries(
        Object.entries(formInputs).filter(([_, value]) => {
          if (typeof value === "string") return value.trim() !== "";
          if (typeof value === "boolean") return value === true;
          return value !== null && value !== undefined;
        })
      );

      const obj = {
        ...estimationData,
        estimationDetailsRemarks: getRemarks?.estimationDetailsRemarks,
        additionalComponent: filteredFormInputs,
        componentBlocks: componentBlockData,
        buildings: buildings,
        buildingCount: buildingCount,
        activeBuildingId: activeBuildingId,
        grandTotalPrice: grandTotals?.totalPrice,
        grandTotalWeight: grandTotals?.totalWeight,
        draftStatus: "",
        headerStatus: "Estimation Created",
        estHeaderStatus: "Estimation Created",
        documentNumber: estimationData?.estimationNr || "",
      };
      setDisabled(true);
      const item = await ItemService.updateEstimation(obj);

      if (item?.status === 200) {
        toast.success(item?.message || "Updated successfully", {
          duration: 2000,
          position: "top-right",
        });

        navigate(
          CustomerConstants.CUSTOMER_V4_CUSTOMER_ESTIMATE_SPECIFICATION_LIST
        );
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    } catch (error) {
      console.error("Update failed:", error);
      toast.error("Something went wrong, please try again later!", {
        duration: 4000,
        position: "top-right",
      });
    }
    setDisabled(false);
  };
  const handleFormInputChange = (e) => {
    const { name, value } = e.target;

    setRemarks((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const componentBlocks = {
    builtUpMembers: {
      icon: "BU",
      title: "Built-Up Members",
      subtitle: "Built-Up Members details",
      fields: [
        { label: "Job No (Built-Up Members)", name: "jobNoBuiltUpMembers" },
      ],
    },
    leftSideWall: {
      icon: "LSW",
      title: "Left Side Wall",
      subtitle: "Left Side Wall details",
      fields: [{ label: "Job No (Left Side Wall)", name: "jobNoLeftSideWall" }],
    },
    rightSideWall: {
      icon: "RSW",
      title: "Right Side Wall",
      subtitle: "Right Side Wall details",
      fields: [
        { label: "Job No (Right Side Wall)", name: "jobNoRightSideWall" },
      ],
    },
    frontEndWall: {
      icon: "FEW",
      title: "Front End Wall",
      subtitle: "Front End Wall details",
      fields: [{ label: "Job No (Front End Wall)", name: "jobNoFrontEndWall" }],
    },
    backEndWall: {
      icon: "BEW",
      title: "Back End Wall",
      subtitle: "Back End Wall details",
      fields: [{ label: "Job No (Back End Wall)", name: "jobNoBackEndWall" }],
    },
    roof01: {
      icon: "R1",
      title: "Roof-01",
      subtitle: "Roof-01 details",
      fields: [{ label: "Job No (Roof-01)", name: "jobNoRoof01" }],
    },
    roof02: {
      icon: "R2",
      title: "Roof-02",
      subtitle: "Roof-02 details",
      fields: [{ label: "Job No (Roof-02)", name: "jobNoRoof02" }],
    },
    pipeStrut: {
      icon: "PS",
      title: "Pipe Strut",
      subtitle: "Pipe Strut details",
      fields: [{ label: "Job No (Pipe Strut)", name: "jobNoPipeStrut" }],
    },
    pipeBracing: {
      icon: "PB",
      title: "Pipe Bracing",
      subtitle: "Pipe Bracing details",
      fields: [{ label: "Job No (Pipe Bracing)", name: "jobNoPipeBracing" }],
    },
    hr: {
      icon: "HRM",
      title: "HR",
      subtitle: "HR details",
      fields: [{ label: "Job No (HR)", name: "jobNoHr" }],
    },
    portalBracing: {
      icon: "PBM",
      title: "Portal Bracing",
      subtitle: "Portal Bracing details",
      fields: [
        { label: "Job No (Portal Bracing)", name: "jobNoPortalBracing" },
      ],
    },
    leanTo: {
      icon: "LT",
      title: "Lean-To",
      subtitle: "Lean-To details",
      fields: [{ label: "Job No (Lean-To)", name: "jobNoLeanTo" }],
    },
    canopy: {
      icon: "CP",
      title: "Canopy",
      subtitle: "Canopy details",
      fields: [{ label: "Job No (Canopy)", name: "jobNoCanopy" }],
    },
    frameOpening: {
      icon: "FO",
      title: "Frame Opening",
      subtitle: "Frame Opening details",
      fields: [{ label: "Job No (Frame Opening)", name: "jobNoFrameOpening" }],
    },
    partitionWall: {
      icon: "PW",
      title: "Partition Wall",
      subtitle: "Partition Wall details",
      fields: [
        { label: "Job No (Partition Wall)", name: "jobNoPartitionWall" },
      ],
    },
    ridgeVentilator: {
      icon: "RV",
      title: "Ridge Ventilator",
      subtitle: "Ridge Ventilator details",
      fields: [
        { label: "Job No (Ridge Ventilator)", name: "jobNoRidgeVentilator" },
      ],
    },
    turboFans: {
      icon: "TF",
      title: "Turbo Fans",
      subtitle: "Turbo Fans details",
      fields: [{ label: "Job No (Turbo Fans)", name: "jobNoTurboFans" }],
    },
    cageLadder: {
      icon: "CL",
      title: "Cage Ladder",
      subtitle: "Cage Ladder details",
      fields: [{ label: "Job No (Cage Ladder)", name: "jobNoCageLadder" }],
    },
    craneBeam: {
      icon: "CB",
      title: "Crane Beam",
      subtitle: "Crane Beam details",
      fields: [{ label: "Job No (Crane Beam)", name: "jobNoCraneBeam" }],
    },
    mezzanine: {
      icon: "MZ",
      title: "Mezzanine",
      subtitle: "Mezzanine details",
      fields: [{ label: "Job No (Mezzanine)", name: "jobNoMezzanine" }],
    },
    fascia: {
      icon: "FA",
      title: "Fascia",
      subtitle: "Fascia details",
      fields: [{ label: "Job No (Fascia)", name: "jobNoFascia" }],
    },
    louvers: {
      icon: "LO",
      title: "Louvers",
      subtitle: "Louvers details",
      fields: [{ label: "Job No (Louvers)", name: "jobNoLouvers" }],
    },
    structuralLouver: {
      icon: "SL",
      title: "Structural Louver",
      subtitle: "Structural Louver details",
      fields: [
        { label: "Job No (Structural Louver)", name: "jobNoStructuralLouver" },
      ],
    },
    industrialLouver: {
      icon: "IL",
      title: "Industrial Louver",
      subtitle: "Industrial Louver details",
      fields: [
        { label: "Job No (Industrial Louver)", name: "jobNoIndustrialLouver" },
      ],
    },
    staircase: {
      icon: "SC",
      title: "Staircase",
      subtitle: "Staircase details",
      fields: [{ label: "Job No (Staircase)", name: "jobNoStaircase" }],
    },
    handrail: {
      icon: "HRL",
      title: "Handrail",
      subtitle: "Handrail details",
      fields: [{ label: "Job No (Handrail)", name: "jobNoHandrail" }],
    },
    hotRolled: {
      icon: "HR",
      title: "Hot Rolled",
      subtitle: "Hot Rolled details",
      fields: [
        { label: "Job No (Hot Rolled)", name: "jobNoHotRolled" },
        { label: "Quote No (Hot Rolled)", name: "quoteNoHotRolled" },
      ],
    },
    others: {
      icon: "OT",
      title: "Others",
      subtitle: "Other details",
      fields: [
        { label: "Job No (Others)", name: "jobNoOthers" },
        { label: "Quote No (Others)", name: "quoteNoOthers" },
      ],
    },
  };

  // material bocks
  const [modalShow, setModalShow] = useState(false);
  const [activeBlockIndex, setActiveBlockIndex] = useState(null);
  // eslint-disable-next-line
  const [blocks, setBlocks] = useState([
    {
      id: Date.now(),
      title: "Roof #1",
      getProductDetailsData: [],
      isVisible: true,
    },
  ]);
  /** Generic inputs (quantity, pieceMeasurement, unitPrice, …) */
  // const handleInputChange = (blockIndex, local_id, event, type) => {
  //   const { name, value } = event.target;
  //   if (type === "Number" && value !== "" && isNaN(value)) {
  //     return;
  //   }
  //   setBlocks((prev) =>
  //     prev.map((b, i) => {
  //       if (i !== blockIndex) return b;
  //       const updated = b.getProductDetailsData.map((row) =>
  //         row.local_id === local_id
  //           ? recalcDerived({ ...row, [name]: value })
  //           : row
  //       );
  //       return { ...b, getProductDetailsData: updated };
  //     })
  //   );
  // };

  // const handleInputChangeForComponent = (componentKey, local_id, e, type) => {
  //   const { name, value } = e.target;

  //   setComponentBlockData((prev) => {
  //     const buildingData = prev[componentKey]?.[activeBuildingId] || [];
  //     return {
  //       ...prev,
  //       [componentKey]: {
  //         ...prev[componentKey],
  //         [activeBuildingId]: buildingData.map((row) => {
  //           if (row.local_id === local_id) {
  //             const updatedRow = {
  //               ...row,
  //               [name]: type === "Number" ? Number(value) || "" : value,
  //             };

  //             let xAccess = Number(updatedRow.xAccess) || 0;
  //             let yAccess = Number(updatedRow.yAccess) || 0;
  //             const unitWeight = Number(updatedRow.unitWeight) || 0;
  //             const pieceMeasure = Number(updatedRow.pieceMeasure) || 0;
  //             const wtModifier = Number(updatedRow.unitWeightModifier) || 1;
  //             const prModifier = Number(updatedRow.unitPriceModifier) || 1;
  //             const unitPrice = Number(updatedRow.unitPrice) || 0;
  //             const quantity = Number(updatedRow.quantity) || 0;

  //             // --- Handle BUF code logic ---
  //             let avg;
  //             if (updatedRow.code?.toUpperCase().startsWith("BUF")) {
  //               // Ignore yAccess and hide Final Depth
  //               yAccess = 0;
  //               avg = xAccess / 1000;
  //               updatedRow.hideFinalDepth = true; // optional flag to hide UI
  //             } else {
  //               avg = (xAccess / 1000 + yAccess / 1000) / 2;
  //               updatedRow.hideFinalDepth = false;
  //             }

  //             const pieceWeight = avg * unitWeight * pieceMeasure * wtModifier;
  //             const totalWeight = quantity * pieceWeight;
  //             const price = totalWeight * unitPrice * prModifier;
  //             const totalPrice = quantity * price;

  //             updatedRow.avg = avg ? avg.toFixed(3) : "";
  //             updatedRow.pieceWeight = pieceWeight
  //               ? pieceWeight.toFixed(3)
  //               : "";
  //             updatedRow.totalWeight = totalWeight
  //               ? totalWeight.toFixed(3)
  //               : "";
  //             updatedRow.price = price ? price.toFixed(3) : "";
  //             updatedRow.totalPrice = totalPrice ? totalPrice.toFixed(3) : "";

  //             return updatedRow;
  //           }
  //           return row;
  //         }),
  //       },
  //     };
  //   });
  // };

  const restrictDecimals = (value) => {
  if (value === "") return "";
  // allow up to 3 decimals, optional integer part
  return value.replace(/^(\d*)(\.(\d{0,3})?)?$/, (m, intPart, decPart) =>
    decPart ? (intPart || "0") + decPart : intPart
  );
};
 
  /** Generic inputs (quantity, pieceMeasurement, unitPrice, …) */
  const handleInputChange = (
  blockIndex,
  local_id,
  event,
  type,
  formatOnBlur = false
) => {
  const { name, value } = event.target;
 
  let processedValue = value;
 
  if (name === "pieceMeasure") {
    // decimals up to 3
    if (!formatOnBlur) {
      processedValue = restrictDecimals(value);
    } else if (value !== "") {
      const num = parseFloat(value);
      processedValue = !isNaN(num) ? num.toFixed(3) : "";
    }
  } else if (name === "quantity") {
    // whole numbers only
    if (!formatOnBlur) {
      processedValue = value.replace(/[^0-9]/g, "");
    } else if (value !== "") {
      const num = parseInt(value, 10);
      processedValue = isNaN(num) ? "" : num;
    }
  } else if (type === "Number") {
    if (processedValue !== "" && isNaN(Number(processedValue))) return;
  }
 
  setBlocks((prev) =>
    prev.map((b, i) => {
      if (i !== blockIndex) return b;
 
      const updated = b.getProductDetailsData.map((row) =>
        row.local_id === local_id
          ? recalcDerived({ ...row, [name]: processedValue })
          : row
      );
 
      return { ...b, getProductDetailsData: updated };
    })
  );
};
 
  const handleInputChangeForComponent = (componentKey, local_id, e, type, formatOnBlur = false) => {
    const { name, value } = e.target;
 
     let processedValue = value;
 
  // 1) Piece Measure: decimal up to 3 places
  if (name === "pieceMeasure") {
    if (!formatOnBlur) {
      processedValue = restrictDecimals(value);
    } else if (value !== "") {
      const num = parseFloat(value);
      processedValue = !isNaN(num) ? num.toFixed(3) : "";
    }
  }
 
  // 2) Quantity: whole numbers only
  else if (name === "quantity") {
    if (!formatOnBlur) {
      processedValue = value.replace(/[^0-9]/g, "");
    } else if (value !== "") {
      const num = parseInt(value, 10);
      processedValue = isNaN(num) ? "" : num;
    }
  }
 
  // 3) Other numeric fields
  else if (type === "Number") {
    if (processedValue !== "" && isNaN(Number(processedValue))) {
      return;
    }
  }
 
    setComponentBlockData((prev) => {
      const buildingData = prev[componentKey]?.[activeBuildingId] || [];
      return {
        ...prev,
        [componentKey]: {
          ...prev[componentKey],
          [activeBuildingId]: buildingData.map((row) => {
            if (row.local_id === local_id) {
              const updatedRow = {
                ...row,
                [name]: processedValue,
              };
 
              let xAccess = Number(updatedRow.xAccess) || 0;
              let yAccess = Number(updatedRow.yAccess) || 0;
              const unitWeight = Number(updatedRow.unitWeight) || 0;
              const pieceMeasure = Number(updatedRow.pieceMeasure) || 0;
              const wtModifier = Number(updatedRow.unitWeightModifier) || 1;
              const prModifier = Number(updatedRow.unitPriceModifier) || 1;
              const unitPrice = Number(updatedRow.unitPrice) || 0;
              const quantity = Number(updatedRow.quantity) || 0;
 
              // --- Handle BUF code logic ---
              let avg;
              if (updatedRow.code?.toUpperCase().startsWith("BUF")) {
                // Ignore yAccess and hide Final Depth
                yAccess = 0;
                avg = xAccess / 1000;
                updatedRow.hideFinalDepth = true; // optional flag to hide UI
              } else {
                avg = (xAccess / 1000 + yAccess / 1000) / 2;
                updatedRow.hideFinalDepth = false;
              }
 
              const pieceWeight = avg * unitWeight * pieceMeasure * wtModifier;
              const totalWeight = quantity * pieceWeight;
              const price = totalWeight * unitPrice * prModifier;
              const totalPrice = quantity * price;
 
              updatedRow.avg = avg ? avg.toFixed(3) : "";
              updatedRow.pieceWeight = pieceWeight
                ? pieceWeight.toFixed(3)
                : "";
              updatedRow.totalWeight = totalWeight
                ? totalWeight.toFixed(3)
                : "";
              updatedRow.price = price ? price.toFixed(3) : "";
              updatedRow.totalPrice = totalPrice ? totalPrice.toFixed(3) : "";
 
              return updatedRow;
            }
            return row;
          }),
        },
      };
    });
  };

  /** Delete only inside that block */
  const removeProductDetails = (blockIndex, local_id) => {
    setBlocks((prev) =>
      prev.map((b, i) => {
        if (i !== blockIndex) return b;
        const filtered = b.getProductDetailsData
          .filter((r) => r.local_id !== local_id)
          .map((r, idx) => ({ ...r, local_id: idx + 1 }));
        return { ...b, getProductDetailsData: filtered };
      })
    );
  };

  const removeProductDetailsForComponent = (key, local_id) => {
    setComponentBlockData((prev) => {
      const buildingData = prev[key]?.[activeBuildingId] || [];
      const filtered = buildingData
        .filter((r) => r.local_id !== local_id)
        .map((r, idx) => ({ ...r, local_id: idx + 1 }));

      return {
        ...prev,
        [key]: {
          ...prev[key],
          [activeBuildingId]: filtered,
        },
      };
    });
  };

  const handleMaterialCodeChange = (blockIndex, local_id, codeInput) => {
    const code = (codeInput || "").toUpperCase().trim();
    // console.log(">>code ",blockIndex, local_id, codeInput)

    setBlocks((prev) =>
      prev.map((b, i) => {
        if (i !== blockIndex) return b;

        const updated = b.getProductDetailsData.map((row) => {
          if (row.local_id !== local_id) return row;

          const match = materialCatlog.find((m) => m.code === code);

          if (!match) {
            return {
              ...row,
              materialCode: codeInput,
              materialLongText: "",
              description: "",
              uOM: "",
              unitWeight: "",
              pieceWeight: "",
              unitPrice: "",
              totalWeight: "",
              price: "",
              totalPrice: "",
              unitValue: "",
              xAccess: "",
              yAccess: "",
              materialLongDescription: "",
            };
          }

          let xAccess = Number(row.xAccess) || 0;
          let yAccess = Number(row.yAccess) || 0;

          if (match.code.toUpperCase().startsWith("BUF")) {
            yAccess = 0;
          }

          const avg = (xAccess / 1000 + yAccess / 1000) / 2;

          const pieceMeasure = Number(row.pieceMeasurement) || 1;
          const wtModifier = Number(match.unitWeightModifier) || 1;
          const unitWeight = Number(match.unitWeight) || 0;
          const unitPrice = Number(match.unitPrice) || 0;
          const quantity = Number(row.quantity) || 0;

          const pieceWeight = avg * unitWeight * pieceMeasure * wtModifier;
          const totalWeight = pieceWeight;
          const totalPrice = totalWeight * unitPrice;
          const price = totalPrice * quantity;

          return {
            ...row,
            materialCode: match.code,
            description: match.description,
            uOM: match.unit,
            unitWeight: match.unitWeight,
            pieceWeight: pieceWeight.toFixed(3),
            unitPrice: match.unitPrice,
            totalWeight: totalWeight.toFixed(3),
            price: price.toFixed(2),
            totalPrice: totalPrice.toFixed(2),
            unitValue: match.unitWeightModifier,
            xAccess,
            yAccess,
            avg: avg.toFixed(3),
          };
        });

        return { ...b, getProductDetailsData: updated };
      })
    );
  };

  const handleMaterialCodeChangeForComponent = (
    key,
    local_id,
    codeInput,
    selectedMaterial
  ) => {
    // console.log(">>selectedMaterial", selectedMaterial);

    setComponentBlockData((prev) => {
      const buildingData = prev[key]?.[activeBuildingId] || [];

      return {
        ...prev,
        [key]: {
          ...prev[key],
          [activeBuildingId]: buildingData.map((row) => {
            if (row.local_id !== local_id) return row;

            if (!selectedMaterial) {
              return {
                ...row,
                code: codeInput,
                description: "",
                unit: "",
                unitWeight: "",
                pieceWeight: "",
                unitPrice: "",
                totalWeight: "",
                price: "",
                totalPrice: "",
                unitWeightModifier: "",
                unitPriceModifier: "",
                xAccess: "",
                yAccess: "",
                materialLongDescription: "",
              };
            }

            // Use the correct property names from your API response
            const materialCode =
              selectedMaterial.materialCode || selectedMaterial.code || "";
            const materialGroup =
              selectedMaterial.materialGroup ||
              selectedMaterial.materialGroup ||
              "";
            const materialGroupCode =
              selectedMaterial.materialGroupCode ||
              selectedMaterial.materialGroupCode ||
              "";
            const materialDescription =
              selectedMaterial.materialDescription ||
              selectedMaterial.description ||
              "";
            const materialUnit = selectedMaterial.unit || "";
            const materialUnitWeight = selectedMaterial.unitWeight || 0;
            const materialUnitPrice = selectedMaterial.unitPrice || 0;
            const materialUnitWeightModifier =
              selectedMaterial.unitWeightModifier || 1;
            const materialUnitPriceModifier =
              selectedMaterial.unitPriceModifier || 1;

            let xAccess = Number(row.xAccess) || 0;
            let yAccess = Number(row.yAccess) || 0;

            if (materialCode.toUpperCase().startsWith("BUF")) {
              yAccess = 0;
            }

            const avg = (xAccess / 1000 + yAccess / 1000) / 2;
            const pieceMeasure = Number(row.pieceMeasure) || 1;
            const wtModifier = Number(materialUnitWeightModifier) || 1;
            const unitWeight = Number(materialUnitWeight) || 0;
            const unitPrice = Number(materialUnitPrice) || 0;
            const quantity = Number(row.quantity) || 0;

            const pieceWeight = avg * unitWeight * pieceMeasure * wtModifier;
            const totalWeight = pieceWeight;
            const totalPrice = totalWeight * unitPrice;
            const price = totalPrice * quantity;

            return {
              ...row,
              code: materialCode,
              description: materialDescription,
              unit: materialUnit,
              materialGroup: materialGroup,
              materialGroupCode: materialGroupCode,
              unitWeight: materialUnitWeight,
              pieceWeight: pieceWeight.toFixed(3),
              unitPrice: materialUnitPrice,
              totalWeight: totalWeight.toFixed(3),
              price: price.toFixed(2),
              totalPrice: totalPrice.toFixed(2),
              unitWeightModifier: materialUnitWeightModifier,
              unitPriceModifier: materialUnitPriceModifier,
              xAccess,
              yAccess,
              avg: avg.toFixed(3),
            };
          }),
        },
      };
    });
  };
  const handleGetSelectedMaterial = (selectedData, blockIndex) => {
    setBlocks((prev) =>
      prev.map((b, i) => {
        if (i !== blockIndex) return b;
        const merged = [
          ...b.getProductDetailsData,
          ...selectedData.map((item, idx) => ({
            local_id: b.getProductDetailsData.length + idx + 1,
            materialCode: item.code || "",
            materialLongText: item.description || "",
            // description: item.description + xAccess + yAccess,
            uOM: item.unit || "",
            unitWeight: item.unitWeight || "",
            pieceWeight: item.pieceWeight || "",
            quantity: item.quantity || "",
            pieceMeasurement: item.pieceMeasure || 1,
            unitPrice: item.unitPrice || "",
            totalWeight: item.totalWeight || "",
            price: item.price || "",
            totalPrice: item.totalPrice || "",
            unitValue: item.unitWeightModifier || "",
            xAccess: item.xAccess || "",
            yAccess: item.yAccess || "",
            accOnOff: false,
            orderQuantityLoad: "",
            dispatchDate: getTodayDate(""),
            orderStatus: "Pending",
          })),
        ];

        return {
          ...b,
          getProductDetailsData: merged.map((row, idx) => ({
            ...row,
            local_id: idx + 1,
          })),
        };
      })
    );
  };

  const handleGetSelectedMaterialForComponent = (selectedData, key) => {
    setComponentBlockData((prev) => {
      const currentBuildingData = prev[key]?.[activeBuildingId] || [];

      const newData = [
        ...currentBuildingData,
        ...selectedData.map((item, idx) => {
          const code = item.code || "";

          let xAccess = Number(item.xAccess) || 0;
          let yAccess = Number(item.yAccess) || 0;
          if (code.toUpperCase().startsWith("BUF")) {
            yAccess = 0;
          }

          const avg = (xAccess / 1000 + yAccess / 1000) / 2;
          const quantity = Number(item.quantity) || 0;
          const pieceMeasure = Number(item.pieceMeasure) || 0;
          const wtModifier = Number(item.unitWeightModifier) || 1;
          const unitPrice = Number(item.unitPrice) || 0;
          const unitWeight = Number(item.unitWeight) || 0;

          const pieceWeight = avg * unitWeight * pieceMeasure * wtModifier;
          const totalWeight = pieceWeight;
          const totalPrice = totalWeight * unitPrice;
          const price = totalPrice;

          return {
            local_id: currentBuildingData.length + idx + 1,
            code,
            description: item.description || "",
            materialGroup: item.materialGroup || "",
            materialGroupCode: item.materialGroupCode || "",
            quantity: quantity || "",
            pieceMeasure: pieceMeasure || "",
            unit: item.unit || "",
            unitWeight: unitWeight || "",
            unitPrice: unitPrice || "",
            pieceWeight: pieceWeight ? pieceWeight.toFixed(3) : "",
            totalWeight: totalWeight ? totalWeight.toFixed(3) : "",
            price: price ? price.toFixed(2) : "",
            totalPrice: totalPrice ? totalPrice.toFixed(2) : "",
            unitWeightModifier: wtModifier || "1",
            unitPriceModifier: item.unitPriceModifier || "1",
            remarks: item.remarks || "",
            surfacePaintArea: item.surfacePaintArea || "",
            xAccess: xAccess,
            yAccess: yAccess,
            avg: avg ? avg.toFixed(3) : "",
          };
        }),
      ];

      // Reindex local_id
      const reindexedData = newData.map((item, index) => ({
        ...item,
        local_id: index + 1,
      }));

      return {
        ...prev,
        [key]: {
          ...prev[key],
          [activeBuildingId]: reindexedData,
        },
      };
    });
  };
  const [materialCatlog, setmaterialCatlog] = useState({});

  //load matreila data

  useEffect(() => {
    let obj = {
      queryName: "Get_ALL_Material",
    };
    ItemService.generateCustomerQueryHb(obj)
      .then((res) => {
        if (res?.data?.length) {
          // Ensure it's an array
          setmaterialCatlog(Array.isArray(res.data) ? res.data : []);
        } else {
          setmaterialCatlog([]);
        }
      })
      .catch((error) => {
        console.error("Failed to fetch material details:", error);
        toast.error("Failed to fetch material details!");
        setmaterialCatlog([]);
      });
  }, []);

  const getProductDetailsCol = (identifier, isComponent = false, data = []) => {
    const hasBUWorBUF = data.some(
      (row) =>
        row.code?.toUpperCase().startsWith("BUW") ||
        row.code?.toUpperCase().startsWith("BUF")
    );

    const columns = [
      {
        name: "Sl.No",
        selector: (row) => row.local_id || "--",
        cell: (row) => (row.code === "TOTAL" ? "" : <>{row.local_id}.</>),
        width: "80px",
      },
      {
        name: "Material Code & Description",
        selector: (row) => row.code,
        cell: (row) => {
          const cleanNumber = (val) => {
            const str = String(val ?? "");
            const num = parseFloat(str.replace(/[^0-9.]/g, ""));
            return isNaN(num) ? "" : num;
          };

          const handleDepthChange = (field, value) => {
            const numericValue = cleanNumber(value);
            const event = { target: { name: field, value: numericValue } };
            if (isComponent)
              handleInputChangeForComponent(
                identifier,
                row.local_id,
                event,
                "Number"
              );
            else handleInputChange(identifier, row.local_id, event, "Number");
          };

          return (
            <div
              style={{ display: "flex", flexDirection: "column", gap: "5px" }}
            >
              {/* ✅ Material Code Input */}
              <InputField
                type="text"
                className="inputBox mt-1"
                name="code"
                placeholder="Enter Material Code"
                value={row.code || ""}
                onChange={(e) => {
                  const enteredCode = e.target.value.trim();
                  const selectedMaterial = Array.isArray(materialCatlog)
                    ? materialCatlog.find(
                        (item) =>
                          item.code &&
                          item.code.toLowerCase() === enteredCode.toLowerCase()
                      )
                    : null;

                  if (isComponent)
                    handleMaterialCodeChangeForComponent(
                      identifier,
                      row.local_id,
                      enteredCode,
                      selectedMaterial
                    );
                  else
                    handleMaterialCodeChange(
                      identifier,
                      row.local_id,
                      enteredCode,
                      selectedMaterial
                    );
                }}
                style={{
                  width: "180px",
                  fontSize: "13px",
                  padding: "4px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                }}
              />

              {/* ✅ Description */}
              <div
                style={{ fontSize: "13px", color: "#444", lineHeight: "1.3" }}
              >
                {row?.description || row?.materialDescription || "--"}
              </div>

              {/* ✅ Show Initial/Final fields only when NOT from MTO */}
              {!row.isFromMto &&
                (row.code?.startsWith("BUF") ||
                  row.code?.startsWith("BUW")) && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      fontSize: "13px",
                      color: "#333",
                      marginTop: "1px",
                      flexWrap: "wrap",
                    }}
                  >
                    <span>(Initial:</span>
                    <span
                      contentEditable
                      suppressContentEditableWarning
                      spellCheck={false}
                      style={{
                        display: "inline-block",
                        minWidth: "35px",
                        borderBottom: "1px dotted red",
                        outline: "none",
                        textAlign: "center",
                        cursor: "text",
                      }}
                      onBlur={(e) =>
                        handleDepthChange(
                          "xAccess",
                          e.currentTarget.textContent.trim()
                        )
                      }
                    >
                      {row.xAccess || ""}
                    </span>
                    {!row.hideFinalDepth && (
                      <>
                        <span>, Final:</span>
                        <span
                          contentEditable
                          suppressContentEditableWarning
                          spellCheck={false}
                          style={{
                            display: "inline-block",
                            minWidth: "35px",
                            borderBottom: "1px dotted red",
                            outline: "none",
                            textAlign: "center",
                            cursor: "text",
                          }}
                          onBlur={(e) =>
                            handleDepthChange(
                              "yAccess",
                              e.currentTarget.textContent.trim()
                            )
                          }
                        >
                          {row.yAccess || ""}
                        </span>
                      </>
                    )}
                    )
                  </div>
                )}
            </div>
          );
        },
        width: "320px",
        wrap: true,
      },
      {
        name: "Avg",
        cell: (row) =>
          row.code === "TOTAL" ? (
            "--"
          ) : (
            <InputField
              className="inputBox mt-1"
              name="avg"
              value={row.avg || ""}
              onChange={(e) =>
                isComponent
                  ? handleInputChangeForComponent(
                      identifier,
                      row.local_id,
                      e,
                      "Number"
                    )
                  : handleInputChange(identifier, row.local_id, e, "Number")
              }
              disabled={true}
            />
          ),
        width: "100px",
      },
      // {
      //   name: "Quantity",
      //   cell: (row) =>
      //     row.code === "TOTAL" ? (
      //       "--"
      //     ) : (
      //       <InputField
      //         className="inputBox mt-1"
      //         name="quantity"
      //         value={row.quantity || ""}
      //         onChange={(e) =>
      //           isComponent
      //             ? handleInputChangeForComponent(
      //                 identifier,
      //                 row.local_id,
      //                 e,
      //                 "Number"
      //               )
      //             : handleInputChange(identifier, row.local_id, e, "Number")
      //         }
      //       />
      //     ),
      //   width: "100px",
      // },
      // {
      //   name: "Piece Measure",
      //   cell: (row) =>
      //     row.code === "TOTAL" ? (
      //       "--"
      //     ) : (
      //       <InputField
      //         className="inputBox mt-1"
      //         name="pieceMeasure"
      //         value={
      //           row.pieceMeasure ? Number(row.pieceMeasure).toFixed(3) : ""
      //         }
      //         onChange={(e) =>
      //           isComponent
      //             ? handleInputChangeForComponent(
      //                 identifier,
      //                 row.local_id,
      //                 e,
      //                 "Number"
      //               )
      //             : handleInputChange(identifier, row.local_id, e, "Number")
      //         }
      //       />
      //     ),
      //   width: "100px",
      // },
      {
                    name: "Quantity",
                    cell: (row) =>
                      row.code === "TOTAL" ? (
                        "--"
                      ) : (
                        <InputField
                          className="inputBox mt-1"
                          name="quantity"
                          
                          step={1}
                    value={row.quantity ?? ""}
                    onChange={(e) =>
                      isComponent
                        ? handleInputChangeForComponent(identifier, row.local_id, e, "Number", false)
                        : handleInputChange(identifier, row.local_id, e, "Number", false)
                    }
                    onBlur={(e) =>
                      isComponent
                        ? handleInputChangeForComponent(identifier, row.local_id, e, "Number", true)
                        : handleInputChange(identifier, row.local_id, e, "Number", true)
                    }
                        />
                      ),
                    width: "100px",
            },
            {
                    name: "Piece Measure",
                    cell: (row) =>
                      row.code === "TOTAL" ? (
                        "--"
                      ) : (
                        <InputField
                          className="inputBox mt-1"
                          name="pieceMeasure"
                          // value={
                          //   row.pieceMeasure ? Number(row.pieceMeasure).toFixed(3) : ""
                          // }
                          // onChange={(e) =>
                          //   isComponent
                          //     ? handleInputChangeForComponent(
                          //         identifier,
                          //         row.local_id,
                          //         e,
                          //         "Number"
                          //       )
                          //     : handleInputChange(identifier, row.local_id, e, "Number")
                          // }
                          step={0.001}
                    value={row.pieceMeasure ?? ""}
                    onChange={(e) =>
                      isComponent
                        ? handleInputChangeForComponent(identifier, row.local_id, e, "Number", false)
                        : handleInputChange(identifier, row.local_id, e, "Number", false)
                    }
                    onBlur={(e) =>
                      isComponent
                        ? handleInputChangeForComponent(identifier, row.local_id, e, "Number", true)
                        : handleInputChange(identifier, row.local_id, e, "Number", true)
                    }
                        />
                      ),
                    width: "100px",
      },
      {
        name: "Unit",
        cell: (row) =>
          row.code === "TOTAL" ? (
            "--"
          ) : (
            <div>
              <p style={{ fontWeight: "bold", margin: 0 }}>
                {row.unit || "--"}
              </p>
            </div>
          ),
        width: "100px",
      },
      {
        name: "Weight",
        cell: (row) =>
          row.code === "TOTAL" ? (
            "--"
          ) : (
            <div>
              <p style={{ margin: 0 }}>
                {" "}
                {row.unitWeight ? Number(row.unitWeight).toFixed(3) : "--"}
              </p>
            </div>
          ),
        width: "100px",
      },
      {
        name: "Unit Price",
        cell: (row) =>
          row.code === "TOTAL" ? (
            "--"
          ) : (
            <InputField
              className="inputBox mt-1"
              name="unitPrice"
              value={row.unitPrice || ""}
              onChange={(e) =>
                isComponent
                  ? handleInputChangeForComponent(
                      identifier,
                      row.local_id,
                      e,
                      "Number"
                    )
                  : handleInputChange(identifier, row.local_id, e, "Number")
              }
              disabled={true}
            />
          ),
        width: "100px",
      },
      {
        name: "Piece Weight",
        selector: (row) =>
          row.code === "TOTAL" ? "--" : row.pieceWeight || "--",
        width: "100px",
      },
      // {
      //   name: "Total Weight",
      //   selector: (row) => row.totalWeight || "--",
      //   width: "100px",
      // },
      {
        name: "Total Weight",
        selector: (row) => row.totalWeight?.toFixed(3) || "--",
        cell: (row) =>
          row.code === "TOTAL" ? (
            <div
              style={{
                minWidth: "160px",
                fontWeight: "bold",
                textAlign: "center",
                whiteSpace: "nowrap",
                overflow: "visible",
              }}
            >
              {row.totalWeight}
            </div>
          ) : (
            row.totalWeight || "--"
          ),
        width: "160px",
      },
      {
        name: "Price",
        selector: (row) => (row.code === "TOTAL" ? "--" : row.price || "--"),
        width: "100px",
      },
      {
        name: "Total Price",
        selector: (row) => row.totalPrice || "--",
        cell: (row) =>
          row.code === "TOTAL" ? (
            <div
              style={{
                minWidth: "180px",
                fontWeight: "bold",
                textAlign: "center",
                whiteSpace: "nowrap",
                overflow: "visible",
              }}
            >
              {row.totalPrice}
            </div>
          ) : (
            row.totalPrice || "--"
          ),
        width: "180px",
      },
      {
        name: "Wt. Modifier",
        cell: (row) =>
          row.code === "TOTAL" ? (
            "--"
          ) : (
            <InputField
              className="inputBox mt-1"
              name="unitWeightModifier"
              value={row.unitWeightModifier || ""}
              onChange={(e) =>
                isComponent
                  ? handleInputChangeForComponent(
                      identifier,
                      row.local_id,
                      e,
                      "Number"
                    )
                  : handleInputChange(identifier, row.local_id, e, "Number")
              }
            />
          ),
        width: "100px",
      },
      {
        name: "Price Modifier",
        cell: (row) =>
          row.code === "TOTAL" ? (
            "--"
          ) : (
            <InputField
              className="inputBox mt-1"
              name="unitPriceModifier"
              value={row.unitPriceModifier || ""}
              onChange={(e) =>
                isComponent
                  ? handleInputChangeForComponent(
                      identifier,
                      row.local_id,
                      e,
                      "Number"
                    )
                  : handleInputChange(identifier, row.local_id, e, "Number")
              }
            />
          ),
        width: "100px",
      },
      {
        name: "Surface/Paint",
        selector: (row) => row.surfacePaintArea || "--",
        width: "100px",
      },
      {
        name: "Delete",
        cell: (row) =>
          row.code === "TOTAL" ? (
            "--"
          ) : (
            <button
              onClick={() =>
                isComponent
                  ? removeProductDetailsForComponent(identifier, row.local_id)
                  : removeProductDetails(identifier, row.local_id)
              }
            >
              <i className="bi bi-trash text-danger fs-4" />
            </button>
          ),
        width: "100px",
      },
      {
        name: "Add",
        cell: (row) =>
          row.code === "TOTAL" ? (
            "--"
          ) : (
            <button
              onClick={() => addEmptyRowToComponent(identifier, row.local_id)}
            >
              <i className="bi bi-plus-circle fs-4" />
            </button>
          ),
        width: "80px",
      },
    ];

    if (!hasBUWorBUF) {
      return columns.filter(
        (col) => col.name !== "X Access" && col.name !== "Y Access"
      );
    }

    return columns;
  };
  const recalcDerived = (row) => {
    const totalWeight = num(row.pieceWeight) * num(row.pieceMeasurement);
    const price = num(row.pieceWeight) * num(row.unitPrice);
    const totalPrice = totalWeight * num(row.unitPrice);
    return {
      ...row,
      totalWeight: totalWeight ? Number(totalWeight.toFixed(2)) : "",
      price: price ? Number(price.toFixed(2)) : "",
      totalPrice: totalPrice ? Number(totalPrice.toFixed(2)) : "",
    };
  };

  const [formInputs, setFormInputs] = useState({});

  const [buildingCount, setBuildingCount] = useState(1);
  const [activeBuildingId, setActiveBuildingId] = useState(1);
  const [buildings, setBuildings] = useState([]);

  const initialBlockData = Object.keys(componentBlocks).reduce((acc, key) => {
    acc[key] = {};
    // Initialize data for each building
    buildings.forEach((building) => {
      acc[key][building.id] = [];
    });
    return acc;
  }, {});

  const [componentBlockData, setComponentBlockData] =
    useState(initialBlockData);
  const [getOverallBuildingArea, setOverallBuildingArea] = useState();

  //load first level data
  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem("selectedComponents")) || {};
    const apiData = estimationData || {};

    const merged = { ...apiData, ...saved };
    setFormInputs(merged);
    // setRemarks(estimationDetailsRemarksestimationData?.estimationDetailsRemarks)
    setDisabled(estimationData?.disabled);
    setEdit(estimationData?.edit);
    setBuildings(estimationData?.buildings);
    setBuildingCount(estimationData?.buildingCount);
    setActiveBuildingId(estimationData?.activeBuildingId);
    setOverallBuildingArea(estimationData?.getOverallBuildingArea);
    // optional: reinitialize or update block data
    setComponentBlockData(initialBlockData);

    const initialVisible = Object.keys(componentBlocks).reduce((acc, key) => {
      acc[key] = !!merged[key];
      return acc;
    }, {});
    setVisibleBlocks(initialVisible);
    // eslint-disable-next-line
  }, [estimationData]);

  const addEmptyRowToComponent = (key, afterId = null) => {
    setComponentBlockData((prev) => {
      const currentData = prev[key]?.[activeBuildingId] || [];
      const newLocalId =
        currentData.length > 0
          ? Math.max(...currentData.map((item) => item.local_id)) + 1
          : 1;

      const newRow = {
        local_id: newLocalId,
        code: "",
        description: "",

        unit: "M",
        unitWeight: "",
        pieceWeight: "",
        unitPrice: "",
        totalWeight: "",
        price: "",
        totalPrice: "",
        unitWeightModifier: 1,
        unitPriceModifier: 1,
        surfacePaintArea: "--",
        quantity: "",
        pieceMeasure: "",
        xAccess: "",
        yAccess: "",
        avg: "",
      };

      let newData;
      if (afterId) {
        const index = currentData.findIndex(
          (item) => item.local_id === afterId
        );
        newData = [...currentData];
        newData.splice(index + 1, 0, newRow);
      } else {
        newData = [...currentData, newRow];
      }

      // Reindex local_id
      newData = newData.map((item, index) => ({
        ...item,
        local_id: index + 1,
      }));

      return {
        ...prev,
        [key]: {
          ...prev[key],
          [activeBuildingId]: newData,
        },
      };
    });
  };

  const addProductDetails = (identifier, isComponent = false) => {
    if (isComponent) {
      setActiveComponentKey(identifier);
      setActiveBlockIndex(null);
    } else {
      setActiveBlockIndex(identifier);
      setActiveComponentKey(null);
    }
    setModalShow(true);
  };

  const hideModal = () => {
    setModalShow(false);
    setActiveBlockIndex(null);
    setActiveComponentKey(null);
  };

  useEffect(() => {
    if (estimationData && Object.keys(estimationData).length > 0) {
      setComponentBlockData(
        estimationData?.componentBlocks || initialBlockData
      );
    }
    // eslint-disable-next-line
  }, [estimationData]);
  // upload excel function
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [parsedData, setParsedData] = useState([]);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [showDataModal, setShowDataModal] = useState(false);

  const handleSaveUpload = async (file, camelCaseTitles = []) => {
    // console.log(">>parent component");
    // console.log("Selected Components from child:", camelCaseTitles);
    const allPayloads = [];
    parsedData.forEach((item, index) => {
      const payload = {
        local_id: index + 1,
        code: item.mtoMaterialCode || "",
        description: item.finalItem || "",
        mtoMaterialGroup: item.mtoMaterialGroup || "",
        section: item.section || "",
        quantity: parseFloat(item.qty) || 0,
        pieceMeasure: parseFloat(item.length) || 0,
        unitWeight: parseFloat(item.unitWeight) || 0,
        totalWeight: parseFloat(item.totalWeight) || 0,
        unit: "M",
        unitPrice: parseFloat(item.unitPrice) || 0,
        price: 0,
        totalPrice: 0,
        unitWeightModifier: 1,
        unitPriceModifier: 1,
        surfacePaintArea: "--",
        xAccess: "",
        yAccess: "",
        // avg: "",
        avg: parseFloat(item.avg) || 0,
        isFromMto: !!item.mtoMaterialCode,
      };

      allPayloads.push(payload);
    });

    setComponentBlockData((prev) => {
      const updatedData = { ...prev };

      camelCaseTitles.forEach((componentKey) => {
        updatedData[componentKey] = {
          ...updatedData[componentKey],
          [activeBuildingId]: [
            ...(updatedData[componentKey]?.[activeBuildingId] || []),
            ...allPayloads,
          ],
        };
      });

      return updatedData;
    });

    setShowDataModal(false);
    toast.success("MTO data uploaded successfully!");
  };

  // eslint-disable-next-line
  const [mtoData, setMtodata] = useState([]);
  const handleUploadComplete = async ({ jsonData, file }) => {
    const mappedData = jsonData.map((row) => {
      const section = row["Section"] || "";
      const items = row["Items"] || "";
      const normalized = Object.fromEntries(
        Object.entries(row).map(([key, value]) => [
          key.trim().toLowerCase(),
          value,
        ])
      );

      // Extract last digit from section (e.g. PL5 -> 5)
      const match = section.match(/\d+$/);
      const num = match ? match[0] : "";

      // Determine prefix and group
      let prefix = "";
      let mtoMaterialGroup = "";

      if (items.toLowerCase().includes("web")) {
        prefix = "BUW";
        mtoMaterialGroup = "BUW";
      } else if (items.toLowerCase().includes("flange")) {
        prefix = "BUF";
        mtoMaterialGroup = "BUF";
      }

      // Build combined codes and final item
      const mtoMaterialCode = prefix && num ? `${prefix}${num}` : "";
      const finalItem = prefix && num ? `${items} (${mtoMaterialCode})` : items;

      return {
        slNo: row["Sl. No."] || "",
        items, // original item name
        finalItem, // new column
        mtoMaterialCode, // new column
        mtoMaterialGroup, // new column
        section,
        width: row["Width (mm)"] || 0,
        length: row["Length (mm)"] || 0,
        qty: row["Qty (#)"] || 0,
        unitWeight: row["Unit Weight (Kg)"] || 0,
        totalWeight: row["Total Weight (Kg)"] || 0,
        unitPrice: row["Unit Price"] || 0,
        // avg: row["Avg"] || 0,
        avg: normalized["avg"] || 0,
      };
    });

    setParsedData(mappedData);
    setUploadedFile(file);
    setShowDataModal(true);
    setMtodata(mappedData);
    // console.log(">>mappedData", mappedData);
  };

  const MTOColumns = [
    { name: "Sl. No.", selector: (row) => row.slNo, width: "100px" },
    { name: "Items", selector: (row) => row.items, width: "240px" },
    {
      name: "Material Code",
      selector: (row) => row.mtoMaterialCode,
      width: "160px",
    },
    {
      name: "Material Group",
      selector: (row) => row.mtoMaterialGroup,
      width: "160px",
    },
    { name: "Section", selector: (row) => row.section, width: "120px" },
    { name: "Width (mm)", selector: (row) => row.width, width: "120px" },
    { name: "Length (mm)", selector: (row) => row.length, width: "120px" },
    { name: "Qty (#)", selector: (row) => row.qty, width: "100px" },
    {
      name: "Unit Weight (Kg)",
      selector: (row) => row.unitWeight,
      width: "150px",
    },
    {
      name: "Total Weight (Kg)",
      selector: (row) => row.totalWeight,
      width: "150px",
    },
    {
      name: "Unit Price",
      selector: (row) => row.unitPrice,
      width: "150px",
    },
    {
      name: "Avg",
      selector: (row) => row.avg,
      width: "150px",
    },
  ];
  //============================setbuilding or multip buildings ===============================
  //additional component
  const handleBuildingCheckboxChange = (buildingId, componentName, checked) => {
    setBuildings((prevBuildings) =>
      prevBuildings.map((building) =>
        building.id === buildingId
          ? {
              ...building,
              additionalComponents: {
                ...building.additionalComponents,
                [componentName]: checked,
              },
            }
          : building
      )
    );
  };

  // updated one
  const getCurrentBlockData = (key) => {
    const data = componentBlockData[key]?.[activeBuildingId] ?? [];
    const updatedData = data.map((item) => {
      const totalWeight = item.isFromMto
        ? parseFloat(item.totalWeight || 0)
        : (item.quantity || 0) * (item.pieceWeight || 0);
      const totalPrice = item.isFromMto
        ? parseFloat(item.totalPrice || 0)
        : (item.price || 0) * (item.quantity || 0);

      return {
        ...item,
        totalWeight: parseFloat(totalWeight.toFixed(3)),
        totalPrice: parseFloat(totalPrice.toFixed(3)),
      };
    });

    // No need for 'updatedData?.reduce' anymore as 'updatedData' is guaranteed to be an array
    const overallTotalWeight = updatedData.reduce(
      (sum, item) => sum + parseFloat(item.totalWeight || 0),
      0
    );
    const overallTotalPrice = updatedData.reduce(
      (sum, item) => sum + parseFloat(item.totalPrice || 0),
      0
    );

    // Add a summary row at the end
    const summaryRow = {
      code: "TOTAL",
      description: "",
      unit: "",
      unitWeight: "",
      quantity: "",
      totalWeight: "Total Weight: " + parseFloat(overallTotalWeight),
      unitPrice: "",
      totalPrice: "Total Price: " + parseFloat(overallTotalPrice),
    };

    // 'updatedData' is now guaranteed to be an array, so the spread works
    const finalData = [...updatedData, summaryRow];

    // console.log(">>componentBlockData", finalData);
    return finalData;
  };

  /* handle building input chnages */
  // eslint-disable-next-line
  const handleBuildingInputChange = (e, buildingId) => {
    const { name, value } = e.target;

    setBuildings((prevBuildings) =>
      prevBuildings.map((building) =>
        building.id === buildingId ? { ...building, [name]: value } : building
      )
    );
  };

  // for overall calucalations

  // Use only active building data for totals
  const allRows = Object.keys(componentBlockData || {}).flatMap((key) => {
    const buildingData = componentBlockData[key]?.[activeBuildingId];
    return Array.isArray(buildingData) ? buildingData : [];
  });

  // console.log(">>allRows for active building", allRows);

  const overallTotalWeight = allRows.reduce(
    (acc, row) => acc + (parseFloat(row?.totalWeight) || 0),
    0
  );
  const overallTotalPrice = allRows.reduce(
    (acc, row) => acc + (parseFloat(row?.totalPrice) || 0),
    0
  );

  useEffect(() => {
    // If estimationData is empty or not available, navigate
    if (!estimationData || Object.keys(estimationData).length === 0) {
      navigate(CustomerConstants.CUSTOMER_V4_HB_QUOTATION_LIST);
    }
  }, [estimationData, navigate]);

  const [edit, setEdit] = useState(true);

  const goBack = () => {
    window.history.back();
  };

  const handleEdit = () => {
    setDisabled(false);
    setEdit(!edit);
  };
  const handleCancel = () => {
    setDisabled(true);
    setEdit(!edit);
  };
  //number of builidngs
  const buildingRows = Object.keys(componentBlockData || {}).reduce(
    (acc, blockKey) => {
      const blockObj = componentBlockData[blockKey];

      Object.keys(blockObj || {}).forEach((buildingId) => {
        if (!acc[buildingId]) acc[buildingId] = [];
        const rows = Array.isArray(blockObj[buildingId])
          ? blockObj[buildingId]
          : [];
        acc[buildingId].push(...rows);
      });

      return acc;
    },
    {}
  );
  const buildingTotals = Object.keys(buildingRows).reduce((acc, buildingId) => {
    const rows = buildingRows[buildingId];

    const totalWeight = rows.reduce(
      (sum, row) => sum + (parseFloat(row.totalWeight) || 0),
      0
    );

    const totalPrice = rows.reduce(
      (sum, row) => sum + (parseFloat(row.totalPrice) || 0),
      0
    );

    acc[buildingId] = { totalWeight, totalPrice };
    return acc;
  }, {});
  const grandTotals = Object.keys(buildingTotals).reduce(
    (acc, buildingId) => {
      acc.totalWeight += buildingTotals[buildingId].totalWeight || 0;
      acc.totalPrice += buildingTotals[buildingId].totalPrice || 0;
      return acc;
    },
    { totalWeight: 0, totalPrice: 0 }
  );

  /* 
const activeTotals = buildingTotals[activeBuildingId] || {
  totalWeight: 0,
  totalPrice: 0,
}; */

  // console.log(">>activeTotals",activeTotals)

  //Remarks
  const handleRemarks = (content, buildingId) => {
    setBuildings((prevBuildings) =>
      prevBuildings.map((building) =>
        building.id === buildingId
          ? { ...building, remarksEstimationCreation: content }
          : building
      )
    );
  };
  const toggleCardVisibility10 = (buildingId) => {
    setBuildings((prev) =>
      prev.map((building) =>
        building.id === buildingId
          ? { ...building, isCardVisible10: !building.isCardVisible10 }
          : building
      )
    );
  };
  //handle input change
  const handleBuildingFieldChange = (buildingId, fieldName, value) => {
    setBuildings((prevBuildings) =>
      prevBuildings.map((building) =>
        building.id === buildingId
          ? { ...building, [fieldName]: value }
          : building
      )
    );
  };
  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Estimate Creation</h2>
            <p className="subText">Estimate Creation</p>
            <hr />

            <Row>
              <Col
                xs={2}
                mg={2}
                lg={2}
                className="d-flex justify-content-start"
              >
                {formInputs?.estimationNr && (
                  <button
                    className="btn btn-primary mt-3"
                    onClick={goBack}
                    // disabled={disabled}
                  >
                    <i class="bi bi-arrow-return-left mr-2"></i>
                    Go back
                  </button>
                )}
              </Col>
               { workflow?.workflow_record?.decision?.length > 0 && estimationData?.estimationNr &&
                estimationData?.headerStatus === "Estimation Created" && (
                  <>
                    {edit && (
                      <Col
                        xs={2}
                        mg={{ span: 2, offset: 8 }}
                        lg={{ span: 2, offset: 8 }}
                        className="d-flex justify-content-end"
                      >
                        <button
                          className="btn btn-primary mt-3 "
                          onClick={handleEdit}
                          // disabled={disabled}
                        >
                          Edit
                        </button>
                      </Col>
                    )}
                    {!edit && (
                      <Col
                        xs={2}
                        mg={{ span: 2, offset: 8 }}
                        lg={{ span: 2, offset: 8 }}
                      >
                        <>
                          <button
                            className="btn btn-primary mt-3"
                            onClick={handleSave}
                            // disabled={disabled}
                          >
                            Update
                          </button>
                          <button
                            className="btn btn-danger mt-3"
                            onClick={handleCancel}
                            // disabled={disabled}
                          >
                            Cancel
                          </button>
                        </>
                      </Col>
                    )}
                  </>
                )}


            </Row>
            {/* Estimate details block  */}
            <div className="accordion mt-3 mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">ED</span>
                    </Col>

                    <Col xs={4} md={4} lg={4}>
                      <span className="headerTitle">Estimate details</span>
                      <span className="subHeaderTitle">Estimate details</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          type="date"
                          className="inputBox"
                          label="Date"
                          name="transactionDate"
                          value={formInputs?.transactionDate}
                          // onChange={handleFormInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commLeftRightPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Client Name"
                          name="clientName"
                          id="clientName"
                          // value={formInputs?.[0]?.clientName || ""}
                          value={formInputs?.clientName}
                          // onChange={handleFormInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commLeftRightPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Company Name"
                          name="companyName"
                          id="companyName"
                          value={formInputs?.companyName}
                          // onChange={handleFormInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commLeftRightPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Building name"
                          name="buildingName"
                          id="buildingName"
                          value={formInputs?.buildingName}
                          // onChange={handleFormInputChange}
                          disabled={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          type="text"
                          className="inputBox"
                          label="Sales Person Name"
                          name="salesOfficerName"
                          value={formInputs?.salesOfficerName}
                          // onChange={handleFormInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          type="text"
                          className="inputBox"
                          label="Location"
                          name="location"
                          value={formInputs?.location}
                          // onChange={handleFormInputChange}
                          disabled={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          type="text"
                          className="inputBox"
                          label="Remark"
                          name="remarks"
                          value={formInputs?.remarks}
                          // onChange={handleFormInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          type="text"
                          className="inputBox"
                          label="Time Line (Days)"
                          name="timeLine"
                          value={formInputs?.timeLine}
                          // onChange={handleFormInputChange}
                          disabled
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          type="date"
                          className="inputBox"
                          label="Estimate Start Date"
                          name="estimateStartdate"
                          value={formInputs?.estimateStartdate}
                          // onChange={(e) => {
                          //   handleFormInputChange(e);
                          //   calculateTimeline(
                          //     e.target.value,
                          //     formInputs?.estimateEndDate
                          //   );
                          // }}
                          min={2000}
                          disabled={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          type="date"
                          className="inputBox"
                          label="Estimate End Date"
                          name="estimateEndDate"
                          value={formInputs?.estimateEndDate}
                          // onChange={(e) => {
                          //   handleFormInputChange(e);
                          //   calculateTimeline(
                          //     formInputs?.estimateStartdate,
                          //     e.target.value
                          //   );
                          // }}
                          min={2000}
                          disabled={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          className="inputBox"
                          label="Status"
                          // data={statusOptions}
                          name="estimationStatus"
                          id="estimationStatus"
                          setValue={formInputs?.estimationStatus}
                          // getvalue={setDropdownData}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          className="inputBox"
                          // data={priorityOptions}
                          label="Building Complexity(Priority)"
                          name="priority"
                          id="priority"
                          setValue={formInputs?.priority}
                          // getvalue={setDropdownData}
                          disabled={true}
                        />
                      </Col>

                      {formInputs?.qtnReferenceNr && (
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Quote No"
                            name="qtnReferenceNr"
                            value={formInputs?.qtnReferenceNr || ""}
                            // onChange={handleFormInputChange}
                            disabled={true}
                          />
                        </Col>
                      )}
                      {formInputs?.jobReferenceNr && (
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Job No"
                            name="jobReferenceNr"
                            value={formInputs?.jobReferenceNr || ""}
                            // onChange={handleFormInputChange}
                            disabled={true}
                          />
                        </Col>
                      )}
                      {formInputs?.status === "Hold" && (
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            type="text"
                            className="inputBox"
                            label="Remark (Estimation)"
                            name="remarkestimation"
                            value={formInputs?.remarkestimation}
                            // onChange={handleFormInputChange}
                          />
                        </Col>
                      )}
                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Revision"
                          name="version"
                          id="version"
                          value={formInputs?.version}
                          // onChange={handleFormInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Tonnage"
                          name="estTonnage"
                          id="estTonnage"
                          value={(
                            parseFloat(grandTotals?.totalWeight) / 1000
                          )?.toFixed(3)}
                          // onChange={handleFormInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Estimate Cost"
                          name="estCost"
                          id="estCost"
                          value={grandTotals?.totalPrice}
                          // onChange={handleFormInputChange}
                          disabled={true}
                        />
                      </Col>

                      {/* <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Estimate Area"
                          name="estArea"
                          id="estArea"
                          value={formInputs?.estArea}
                          // onChange={handleFormInputChange}
                          disabled={true}
                        />
                      </Col> */}

                      <Col
                        xs={12}
                        md={4}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Overall Estimation Area"
                          name="overallBuildingArea"
                          value={`${getOverallBuildingArea?.toFixed(3)} Sqm`}
                          readOnly
                          disabled
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          type="number"
                          label="Number of Buildings"
                          className="inputBox"
                          value={buildingCount}
                          // onChange={(e) => {
                          //   let count = parseInt(e.target.value) || 1;
                          //   // Enforce the limit
                          //   count = Math.min(Math.max(1, count), 50);
                          //   setBuildingCount(count);
                          //   handleBuildingCountChange(count);
                          // }}
                          min="1"
                          max="10"
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={6}
                        className="commTopButtonRightLeftPadding"
                      >
                        <TextAreaField
                          label="Remarak"
                          className="inputBox"
                          name="estimationDetailsRemarks"
                          value={getRemarks?.estimationDetailsRemarks}
                          onChange={handleFormInputChange}
                          disabled={disabled}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            <Row>
              <Col xs={12} md={12} lg={12}>
                <div className="card">
                  <div className="card-body pt-3">
                    <ul className="nav nav-tabs nav-tabs-bordered">
                      {buildings.map((building, index) => (
                        <li key={building.id} className="nav-item">
                          <button
                            className={`nav-link ${
                              activeBuildingId === building.id ? "active" : ""
                            }`}
                            style={{
                              backgroundColor:
                                activeBuildingId === building.id
                                  ? "#007bff"
                                  : "transparent",
                              color:
                                activeBuildingId === building.id
                                  ? "#fff"
                                  : "#000",
                              borderRadius: "5px",
                              border: "none",
                              transition: "all 0.3s ease",
                              padding: "8px 16px",
                            }}
                            onClick={() => setActiveBuildingId(building.id)}
                          >
                            Building Estimation {index + 1}
                          </button>
                        </li>
                      ))}
                    </ul>

                    <div
                      className="tab-content pt-2"
                      style={{
                        overflowY: "auto",
                        // maxHeight: "70vh",
                      }}
                    >
                      {buildings.map((building, index) => (
                        <div
                          key={building.id}
                          className={`tab-pane fade ${
                            activeBuildingId === building.id
                              ? "show active"
                              : ""
                          }`}
                        >
                          {/* Building Structure Details Accordion */}
                          <h5 class="bg-table-status bg-table-new-status ml-2 mt-3 p-3">
                            Building Specification {index + 1}{" "}
                          </h5>
                          <Row className="mb-2">
                            <Col xs={12} md={12} lg={12}>
                              <h5 className="mb-2 text-primary">
                                Structure Type
                              </h5>
                            </Col>
                            <Col
                              xs={12}
                              md={3}
                              lg={3}
                              className="commTopButtonRightLeftPadding ml-0"
                            >
                              <ComboboxField
                                className="inputBox"
                                label="Building Types"
                                placeholder=""
                                // data={buildingTypes}
                                name="buildingTypes"
                                code={`buildingTypesCode-${building?.id}`}
                                description="buildingTypesDesc"
                                setValue={building?.buildingTypes || ""}
                                // getvalue={setDropdownData}
                                disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={3}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                className="inputBox"
                                // data={buildingStrctures}
                                label="Building Structure"
                                name="buildingStructure"
                                code={`buildingStructureCode-${building?.id}`}
                                description="buildingStructureDesc"
                                setValue={building?.buildingStructure || ""}
                                // getvalue={setDropdownData}
                                disabled={true}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={3}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                className="inputBox"
                                // data={designs}
                                label="Design"
                                name="design"
                                code={`designCode-${building?.id}`}
                                description="designDesc"
                                setValue={building?.design || ""}
                                // getvalue={setDropdownData}
                                disabled={true}
                              />
                            </Col>

                            <Row>
                              <h5 className="mb-2 text-primary">Estimation</h5>
                              <Col
                                xs={12}
                                md={6}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Tonnage"
                                  name="estTonnage"
                                  value={
                                    (
                                      parseFloat(overallTotalWeight) / 100
                                    )?.toFixed(3) ?? ""
                                  }
                                  disabled={true}
                                />
                              </Col>

                              <Col
                                xs={12}
                                md={6}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Estimate Cost"
                                  name="estCost"
                                  // id={`estCost-${building.id}`}
                                  value={
                                    parseFloat(overallTotalPrice)?.toFixed(3) ??
                                    ""
                                  }
                                  disabled={true}
                                  // onChange={(e) =>
                                  //   handleBuildingInputChange(e, building.id)
                                  // }
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={3}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label={`Estimate Area ${index + 1}`}
                                  name="buildingArea"
                                  value={`${Number(
                                    building.totalArea ||
                                      building.buildingArea ||
                                      0
                                  ).toFixed(4)} Sqm`}
                                  readOnly
                                  disabled
                                />
                              </Col>
                              {/*  <Col
                                xs={12}
                                md={6}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Estimate Area"
                                  name="estArea"
                                  id={`estArea-${building.id}`}
                                  value={building?.estArea || ""}
                                  onChange={(e) =>
                                    handleBuildingInputChange(e, building.id)
                                  }
                                  disabled={false}
                                />
                              </Col> */}
                            </Row>
                          </Row>
                          {/* Only show content for active building */}
                          {activeBuildingId === building.id && (
                            <>
                              <div
                                className="accordion mt-3 mb-4"
                                id="accordionExample"
                              >
                                <div className="accordion-item">
                                  <h2 className="accordion-header">
                                    <Row className="accordion-button">
                                      <Col
                                        xs={1}
                                        md={1}
                                        lg={1}
                                        className="text-left arrowBtn"
                                      >
                                        <i
                                          className={`bi ${
                                            building.isCardVisible3
                                              ? "bi-chevron-right"
                                              : "bi-chevron-down"
                                          }`}
                                          // onClick={() =>
                                          //   toggleCardVisibility3(
                                          //     building.id
                                          //   )
                                          // }
                                        ></i>
                                      </Col>
                                      <Col
                                        xs={1}
                                        md={1}
                                        lg={1}
                                        className="text-center logoBtn"
                                      >
                                        <span className="iconLogo">BS</span>
                                      </Col>

                                      <Col xs={4} md={8} lg={8}>
                                        <span className="headerTitle">
                                          Components {building.id}
                                        </span>
                                        <span className="subHeaderTitle">
                                          Component details
                                        </span>
                                      </Col>
                                      {!disabled && (
                                        <Col
                                          xs={4}
                                          md={2}
                                          lg={2}
                                          className="d-flex justify-content-end"
                                        >
                                          <button
                                            className="btnTable "
                                            // onClick={() => showCashRequestModal()}
                                            onClick={() =>
                                              setShowUploadModal(true)
                                            }
                                          >
                                            MTO Upload
                                          </button>
                                        </Col>
                                      )}
                                    </Row>
                                  </h2>
                                  <div
                                    className={`accordion-collapse collapse show ${
                                      building.isCardVisible3 ? "visible" : ""
                                    }`}
                                  >
                                    <div className="accordion-body pb-5">
                                      <Row>
                                        {/* First Column */}
                                        <Col
                                          xs={12}
                                          md={3}
                                          lg={3}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          {[
                                            "builtUpMembers",
                                            "leftSideWall",
                                            "rightSideWall",
                                            "frontEndWall",
                                            "backEndWall",
                                            "roof01",
                                            "roof02",
                                          ].map((option, index) => {
                                            const currentBuilding =
                                              buildings.find(
                                                (b) => b.id === activeBuildingId
                                              );
                                            const isChecked =
                                              currentBuilding
                                                ?.additionalComponents?.[
                                                option
                                              ] || false;

                                            return (
                                              <div
                                                className="form-check mb-2"
                                                key={option}
                                              >
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  id={`check-${option}-${activeBuildingId}`}
                                                  style={{
                                                    width: "20px",
                                                    height: "20px",
                                                  }}
                                                  checked={isChecked}
                                                  onChange={(e) => {
                                                    const checked =
                                                      e.target.checked;
                                                    handleBuildingCheckboxChange(
                                                      activeBuildingId,
                                                      option,
                                                      checked
                                                    );
                                                  }}
                                                  disabled={disabled}
                                                />
                                                <label
                                                  className="form-check-label ms-2"
                                                  htmlFor={`check-${option}-${activeBuildingId}`}
                                                  style={{ fontSize: "16px" }}
                                                >
                                                  {`${index + 1}. ${option
                                                    .replace(/([A-Z])/g, " $1")
                                                    .toUpperCase()}`}
                                                </label>
                                              </div>
                                            );
                                          })}
                                        </Col>
                                        {/* Second Column */}
                                        <Col
                                          xs={12}
                                          md={3}
                                          lg={3}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          {[
                                            "pipeStrut",
                                            "pipeBracing",
                                            "hr",
                                            "portalBracing",
                                            "leanTo",
                                            "canopy",
                                            "frameOpening",
                                          ].map((option, index) => {
                                            const currentBuilding =
                                              buildings.find(
                                                (b) => b.id === activeBuildingId
                                              );
                                            const isChecked =
                                              currentBuilding
                                                ?.additionalComponents?.[
                                                option
                                              ] || false;

                                            return (
                                              <div
                                                className="form-check mb-2"
                                                key={option}
                                              >
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  id={`check-${option}-${activeBuildingId}`}
                                                  style={{
                                                    width: "20px",
                                                    height: "20px",
                                                  }}
                                                  checked={isChecked}
                                                  onChange={(e) => {
                                                    const checked =
                                                      e.target.checked;
                                                    handleBuildingCheckboxChange(
                                                      activeBuildingId,
                                                      option,
                                                      checked
                                                    );
                                                  }}
                                                  disabled={disabled}
                                                />
                                                <label
                                                  className="form-check-label ms-2"
                                                  htmlFor={`check-${option}-${activeBuildingId}`}
                                                  style={{ fontSize: "16px" }}
                                                >
                                                  {`${index + 8}. ${option
                                                    .replace(/([A-Z])/g, " $1")
                                                    .toUpperCase()}`}
                                                </label>
                                              </div>
                                            );
                                          })}
                                        </Col>

                                        {/* Third Column */}
                                        <Col
                                          xs={12}
                                          md={3}
                                          lg={3}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          {[
                                            "partitionWall",
                                            "ridgeVentilator",
                                            "turboFans",
                                            "cageLadder",
                                            "craneBeam",
                                            "mezzanine",
                                            "fascia",
                                          ].map((option, index) => {
                                            const currentBuilding =
                                              buildings.find(
                                                (b) => b.id === activeBuildingId
                                              );
                                            const isChecked =
                                              currentBuilding
                                                ?.additionalComponents?.[
                                                option
                                              ] || false;

                                            return (
                                              <div
                                                className="form-check mb-2"
                                                key={option}
                                              >
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  id={`check-${option}-${activeBuildingId}`}
                                                  style={{
                                                    width: "20px",
                                                    height: "20px",
                                                  }}
                                                  checked={isChecked}
                                                  onChange={(e) => {
                                                    const checked =
                                                      e.target.checked;
                                                    handleBuildingCheckboxChange(
                                                      activeBuildingId,
                                                      option,
                                                      checked
                                                    );
                                                  }}
                                                  disabled={disabled}
                                                />
                                                <label
                                                  className="form-check-label ms-2"
                                                  htmlFor={`check-${option}-${activeBuildingId}`}
                                                  style={{ fontSize: "16px" }}
                                                >
                                                  {`${index + 15}. ${option
                                                    .replace(/([A-Z])/g, " $1")
                                                    .toUpperCase()}`}
                                                </label>
                                              </div>
                                            );
                                          })}
                                        </Col>
                                        {/* Fourth Column */}
                                        <Col
                                          xs={12}
                                          md={3}
                                          lg={3}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          {[
                                            "louvers",
                                            "structuralLouver",
                                            "industrialLouver",
                                            "staircase",
                                            "handrail",
                                            "hotRolled",
                                            "others",
                                          ].map((option, index) => {
                                            const currentBuilding =
                                              buildings.find(
                                                (b) => b.id === activeBuildingId
                                              );
                                            const isChecked =
                                              currentBuilding
                                                ?.additionalComponents?.[
                                                option
                                              ] || false;

                                            return (
                                              <div
                                                className="form-check mb-2"
                                                key={option}
                                              >
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  id={`check-${option}-${activeBuildingId}`}
                                                  style={{
                                                    width: "20px",
                                                    height: "20px",
                                                  }}
                                                  checked={isChecked}
                                                  onChange={(e) => {
                                                    const checked =
                                                      e.target.checked;
                                                    handleBuildingCheckboxChange(
                                                      activeBuildingId,
                                                      option,
                                                      checked
                                                    );
                                                  }}
                                                  disabled={disabled}
                                                />
                                                <label
                                                  className="form-check-label ms-2"
                                                  htmlFor={`check-${option}-${activeBuildingId}`}
                                                  style={{ fontSize: "16px" }}
                                                >
                                                  {`${index + 22}. ${option
                                                    .replace(/([A-Z])/g, " $1")
                                                    .toUpperCase()}`}
                                                </label>
                                              </div>
                                            );
                                          })}
                                        </Col>
                                      </Row>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* multiple buildings */}
                              <div className="accordion-body pb-5">
                                {Object.keys(componentBlocks)
                                  .filter((key) => {
                                    // Get the current active building
                                    const currentBuilding = buildings.find(
                                      (b) => b.id === activeBuildingId
                                    );
                                    // Check if this component is enabled for the active building
                                    return currentBuilding
                                      ?.additionalComponents?.[key];
                                  })
                                  .map((key) => {
                                    const block = componentBlocks[key];
                                    // const blockData =
                                    //   componentBlockData[key] || [];

                                    return (
                                      <div
                                        key={key}
                                        className="accordion mt-3 mb-4"
                                        id="accordionExample"
                                      >
                                        <div className="accordion-item">
                                          <h2 className="accordion-header">
                                            <Row className="accordion-button">
                                              <Col
                                                xs={1}
                                                className="text-left arrowBtn"
                                              >
                                                <i
                                                  className={`bi ${
                                                    visibleBlocks[key]
                                                      ? "bi-chevron-right"
                                                      : "bi-chevron-down"
                                                  }`}
                                                  onClick={() =>
                                                    toggleCardVisibility(key)
                                                  }
                                                ></i>
                                              </Col>

                                              <Col
                                                xs={1}
                                                className="text-center logoBtn"
                                              >
                                                <span className="iconLogo">
                                                  {block.icon}
                                                </span>
                                              </Col>

                                              <Col xs={4}>
                                                <span className="headerTitle">
                                                  {block.title} {building.id}
                                                </span>
                                                <span className="subHeaderTitle">
                                                  {block.subtitle}
                                                </span>
                                              </Col>

                                              {/* Header buttons */}
                                              {!disabled && (
                                                <Col
                                                  xs={12}
                                                  md={6}
                                                  lg={6}
                                                  className="headerButtonAlign d-flex justify-content-end"
                                                >
                                                  <Col xs={6} md={3} lg={2}>
                                                    <button
                                                      className="btnTable"
                                                      onClick={() =>
                                                        addEmptyRowToComponent(
                                                          key
                                                        )
                                                      }
                                                    >
                                                      +
                                                    </button>
                                                  </Col>
                                                  <Col xs={6} md={3} lg={2}>
                                                    <button
                                                      className="btnTable"
                                                      onClick={() =>
                                                        addProductDetails(
                                                          key,
                                                          true
                                                        )
                                                      }
                                                    >
                                                      <i className="bi bi-plus-lg"></i>{" "}
                                                      Add
                                                    </button>
                                                  </Col>
                                                </Col>
                                              )}
                                            </Row>
                                          </h2>

                                          <div
                                            className={`accordion-collapse collapse show ${
                                              visibleBlocks[key]
                                                ? "visible"
                                                : ""
                                            }`}
                                          >
                                            <div className="accordion-body">
                                              {/* Additional Fields for Each Component */}
                                              {block.fields &&
                                                block.fields.length > 0 && (
                                                  <Row className="mb-3">
                                                    {block.fields.map(
                                                      (field, index) => (
                                                        <Col
                                                          key={field.name}
                                                          xs={12}
                                                          md={6}
                                                          lg={4}
                                                        ></Col>
                                                      )
                                                    )}
                                                  </Row>
                                                )}

                                              {/* Data Table */}
                                              <Row className="pt-2 pb-4">
                                                <Col xs={12} md={12} lg={12}>
                                                  <div
                                                    style={{
                                                      maxHeight: "400px",
                                                      overflowY: "auto",
                                                      overflowX: "auto",
                                                    }}
                                                  >
                                                    <DataTable
                                                      columns={getProductDetailsCol(
                                                        key,
                                                        true,
                                                        getCurrentBlockData(key) // Pass current building's data
                                                      )}
                                                      data={getCurrentBlockData(
                                                        key
                                                      )} // Use current building's data
                                                      pagination={false}
                                                      dense
                                                      fixedHeader
                                                      fixedHeaderScrollHeight="400px"
                                                      highlightOnHover
                                                      striped
                                                    />

                                                    {/* ✅ Total Tonnage display below table */}
                                                    {getCurrentBlockData(key) &&
                                                      getCurrentBlockData(key)
                                                        .length > 0 && (
                                                        <div className="totals-summary d-flex justify-content-start flex-column align-items-start mt-2">
                                                          <div className="total-weight">
                                                            Total Weight:{" "}
                                                            {getCurrentBlockData(
                                                              key
                                                            )
                                                              ?.reduce(
                                                                (acc, row) =>
                                                                  acc +
                                                                  (parseFloat(
                                                                    row.totalWeight
                                                                  ) || 0),
                                                                0
                                                              )
                                                              .toFixed(3)}{" "}
                                                            kg
                                                          </div>

                                                          <div className="total-price">
                                                            Total Price: ₹
                                                            {getCurrentBlockData(
                                                              key
                                                            )
                                                              ?.reduce(
                                                                (acc, row) =>
                                                                  acc +
                                                                  (parseFloat(
                                                                    row.totalPrice
                                                                  ) || 0),
                                                                0
                                                              )
                                                              .toFixed(2)}
                                                          </div>
                                                        </div>
                                                      )}
                                                  </div>
                                                </Col>
                                              </Row>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })}
                              </div>
                            </>
                          )}
                        </div>
                      ))}
                      <div className="overall-total-container mt-4">
                        <div className="d-flex justify-content-start flex-column align-items-start">
                          <div style={{ fontWeight: 600 }}>
                            Overall Total Weight:&nbsp;
                            {overallTotalWeight.toFixed(3)} kg
                          </div>

                          <div style={{ fontWeight: 600 }}>
                            Overall Total Price:&nbsp;₹
                            {overallTotalPrice.toFixed(2)}
                          </div>
                        </div>
                      </div>
                      {/* Remraks */}
                      <div
                        className="tab-content pt-2"
                        style={{ overflowY: "auto" }}
                      >
                        {buildings.map((building, index) => (
                          <div
                            key={building.id}
                            className={`tab-pane fade ${
                              activeBuildingId === building.id
                                ? "show active"
                                : ""
                            }`}
                          >
                            {/* Only show content for active building */}
                            {activeBuildingId === building.id && (
                              <div
                                className="accordion mt-3 mb-4"
                                id="accordionExample"
                              >
                                <div className="accordion-item">
                                  <h2 className="accordion-header">
                                    <Row className="accordion-button">
                                      <Col
                                        xs={1}
                                        md={1}
                                        lg={1}
                                        className="text-left arrowBtn"
                                      >
                                        <i
                                          className={`bi ${
                                            building.isCardVisible10
                                              ? "bi-chevron-right"
                                              : "bi-chevron-down"
                                          }`}
                                          onClick={() =>
                                            toggleCardVisibility10(building.id)
                                          }
                                        ></i>
                                      </Col>
                                      <Col
                                        xs={1}
                                        md={1}
                                        lg={1}
                                        className="text-center logoBtn"
                                      >
                                        <span className="iconLogo">AB</span>
                                      </Col>
                                      <Col xs={4} md={4} lg={4}>
                                        <span className="headerTitle">
                                          Remarks {building.id}
                                        </span>
                                        <span className="subHeaderTitle">
                                          Remarks Section
                                        </span>
                                      </Col>
                                    </Row>
                                  </h2>
                                  <div
                                    className={`accordion-collapse collapse show ${
                                      building.isCardVisible10 ? "visible" : ""
                                    }`}
                                  >
                                    <div className="accordion-body pb-5">
                                      <Row className="p-4">
                                        <Col xs={12} md={12} lg={12}>
                                          <RichTextEditor
                                            value={
                                              building?.remarksEstimationCreation ||
                                              ""
                                            }
                                            onChange={(content) =>
                                              handleRemarks(
                                                content,
                                                building.id
                                              )
                                            }
                                          />
                                        </Col>
                                      </Row>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                      {/* estimation specification input fileds */}
                      <div
                        className="tab-content pt-2"
                        style={{ overflowY: "auto" }}
                      >
                        {buildings.map((building, index) => (
                          <div
                            key={building.id}
                            className={`tab-pane fade ${
                              activeBuildingId === building.id
                                ? "show active"
                                : ""
                            }`}
                          >
                            {/* Only show content for active building */}
                            {activeBuildingId === building.id && (
                              <div
                                className="accordion mt-3 mb-4"
                                id="accordionExample"
                              >
                                <div className="accordion-item">
                                  <h2 className="accordion-header">
                                    <Row className="accordion-button">
                                      <Col
                                        xs={1}
                                        md={1}
                                        lg={1}
                                        className="text-left arrowBtn"
                                      >
                                        <i
                                          className={`bi ${
                                            building.isCardVisible10
                                              ? "bi-chevron-right"
                                              : "bi-chevron-down"
                                          }`}
                                          onClick={() =>
                                            toggleCardVisibility10(building.id)
                                          }
                                        ></i>
                                      </Col>
                                      <Col
                                        xs={1}
                                        md={1}
                                        lg={1}
                                        className="text-center logoBtn"
                                      >
                                        <span className="iconLogo">AB</span>
                                      </Col>
                                      <Col xs={4} md={4} lg={4}>
                                        <span className="headerTitle">
                                          Estimation Specification {building.id}
                                        </span>
                                        <span className="subHeaderTitle">
                                          Estimation Specification
                                        </span>
                                      </Col>
                                    </Row>
                                  </h2>
                                  <div
                                    className={`accordion-collapse collapse show ${
                                      building.isCardVisible10 ? "visible" : ""
                                    }`}
                                  >
                                    <div className="accordion-body pb-5">
                                      <Row className="p-4">
                                        <Col
                                          xs={12}
                                          md={3}
                                          lg={3}
                                          className="commLeftRightPadding"
                                        >
                                          <InputField
                                            label="Roof Bracing"
                                            className="inputBox"
                                            name="roofBracing"
                                            value={building?.roofBracing || ""}
                                            onChange={(e) =>
                                              handleBuildingFieldChange(
                                                building.id,
                                                "roofBracing",
                                                e.target.value
                                              )
                                            }
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={3}
                                          lg={3}
                                          className="commLeftRightPadding"
                                        >
                                          <InputField
                                            label="Side Bracing"
                                            className="inputBox"
                                            name="sideBracing"
                                            value={building?.sideBracing || ""}
                                            onChange={(e) =>
                                              handleBuildingFieldChange(
                                                building.id,
                                                "sideBracing",
                                                e.target.value
                                              )
                                            }
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={3}
                                          lg={3}
                                          className="commLeftRightPadding"
                                        >
                                          <InputField
                                            label="Open wall / Masonary Conditions"
                                            className="inputBox"
                                            name="openWallMasonaryConditions"
                                            value={
                                              building?.openWallMasonaryConditions ||
                                              ""
                                            }
                                            onChange={(e) =>
                                              handleBuildingFieldChange(
                                                building.id,
                                                "openWallMasonaryConditions",
                                                e.target.value
                                              )
                                            }
                                          />
                                        </Col>
                                      </Row>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>

            {/*    <div className="accordion mt-3 mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">R</span>
                    </Col>

                    <Col xs={4} md={4} lg={4}>
                      <span className="headerTitle">Remarks</span>
                      <span className="subHeaderTitle">Remarks</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <RichTextEditor
                        value={formInputs?.estimationCreationRemarks}
                        readOnly={disabled}
                        onChange={(content) => {
                          setFormInputs((prev) => ({
                            ...prev,
                            estimationCreationRemarks: content,
                          }));
                        }}
                      />
                    </Row>
                  </div>
                </div>
              </div>
            </div> */}

            {/* Save Button */}
              {workflow?.workflow_record?.decision?.length > 0 && (<>

<div className="text-end my-4">
              <button
                className="btn btn-success"
                // className="btn btn-primary mt-4  "
                onClick={handleDraft}
                disabled={disabled}
                // disabled={disabled}
              >
                Save as Draft
              </button>
              <button
                className="btn btn-success"
                disabled={disabled}
                onClick={handleSave}
              >
                Save
              </button>
            </div>

</>)}
            
          </div>
        </Col>
        {/* Blocks */}
        {/*  */}
      </Row>
      <EstimateMaterialSelectionModal
        show={modalShow}
        onHide={hideModal}
        onselectedcatdata={(selected) => {
          if (activeBlockIndex !== null) {
            handleGetSelectedMaterial(selected, activeBlockIndex);
          } else if (activeComponentKey) {
            handleGetSelectedMaterialForComponent(selected, activeComponentKey);
          }
        }}
      />
      <EstimateUploadDataViewModal
        show={showDataModal}
        onHide={() => setShowDataModal(false)}
        data={parsedData}
        columns={MTOColumns}
        title="Uploaded MTO"
        file={uploadedFile}
        onClick={handleSaveUpload}
        // disabled={disabled}
        // loading={loading}
      />
      <EstimateUploadModal
        show={showUploadModal}
        onHide={() => setShowUploadModal(false)}
        onUploadComplete={handleUploadComplete}
      />
    </main>
  );
};

export default EstimationCreationworkFlow;
